import { render, staticRenderFns } from "./CustomerSupportsView.vue?vue&type=template&id=44a3f77e&"
import script from "./CustomerSupportsView.vue?vue&type=script&lang=js&"
export * from "./CustomerSupportsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports